module.exports = __webpack_public_path__ + "media/images/exp-three-fe9a01d74b1767954d28b6029eaf0f60.png";